/* eslint-disable */
import { updateTransform } from '../../store/global/gridlayout';
import { createPinnedItem } from './models/PinnedGrid';

export const SELECT_BOX = (state, { layoutName, title }) => {
  state[layoutName].layout.forEach((element) => {
    if (element.i === title) {
      element.selected = true;
    } else {
      element.selected = false;
    }
  });
};

export const MINIMIZE_BOX = (state, { layoutName, title }) => {
  state[layoutName].layout.forEach((element) => {
    if (element.i === title) {
      element.h = 3;
      element.minimized = true;
      element.isResizable = false;
    }
  });
};

export const MAXIMIZE_BOX = (state, { layoutName, title }) => {
  state[layoutName].layout.forEach((element) => {
    if (element.i === title) {
      element.h = element.origH;

      setTimeout(() => {
        element.minimized = false;
        element.isResizable = true;
      }, 2);
    }
  });
};

export const PIN_BOX = (state, { layoutName, title, element }) => {
  element = element.parentElement;

  state[layoutName].layout = state[layoutName].layout.map((elState) => {

    if (elState.i === title) {
      if (elState.isPinned === false) {
        
        // elState.isPinned    = true ;
        // elState.isDraggable = false;
        // elState.zIndex      = 2    ;

        applyPinnedStyle(elState);

        elState.oldTransform = element.style.transform;

        const width = Number.parseFloat(element.style.width);
        const height = Number.parseFloat(element.style.height);


        if (!elState.mutationObserver) {

          elState.mutationObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutationRecord) {

              setTimeout(() => {
                if (elState.isPinned && elState.pinnedCoords) {
                  const {x, y} = elState.pinnedCoords;

                  if (state[layoutName].useCssTransforms) {
                    element.style.transform = updateTransform(x, y);
                  } else {
                    element.style.left = x;
                    element.style.top = y;
                  }

                  setTimeout(() => {
                    elState.position = 'fixed';
                  }, 200)

                }
              }, 0);
            });
          });

          elState.mutationObserver.observe(element, {
            attributes: true,
            attributeFilter: ['style'],
          });
        } else {
          elState.mutationObserver.observe(element, {
            attributes: true,
            attributeFilter: ['style'],
          });
        }

        setTimeout(() => {
        
          if (elState.isPinned) {
            const coords = state[layoutName].pinnedGrid.addItem(createPinnedItem({w: width, h : height, i: elState.i}));
          
            if (coords) {

              const {x, y} = coords;
              elState.pinnedCoords = coords;

              if (state[layoutName].useCssTransforms) {
                element.style.transform = updateTransform(x, y);
              } else {
                element.style.left = x;
                element.style.top = y;
              }


            }
          }

          setTimeout(() => {

            if (elState.isPinned) {

              elState.position = 'fixed';

              console.log(elState);

            }

          }, 200)


        }, 0);
      } else if (elState.isPinned === true) {

        if (elState.mutationObserver) {
          elState.mutationObserver.disconnect();
          elState.mutationObserver = undefined;
        }

        applyUnpinnedStyle(elState);

        setTimeout(() => {

          if (!elState.isPinned) {

            elState.position = 'absolute';

          }

        }, 200)

        state[layoutName].pinnedGrid.removeById(elState.i);


        element.style.transform = elState.oldTransform;
      }
    }
    return elState;
  });
};





const applyPinnedStyle = (elState) => {
  mutate(elState, {
       isPinned    : true ,
      //  isDraggable : false,
       zIndex      : 2    ,
  });
}

const applyUnpinnedStyle = (elState) => {
  mutate(elState, {
       isPinned    : false ,
      //  isDraggable : true,
       zIndex      : 1    ,
  });
}

const makeAbsolutePosition = (elState) => {
  if (!elState.isPinned) {
    mutate(elState,  {
      ...elState,
      position: 'absolute',
    });
  }
}

const makeFixedPosition = (elState) => {
  if (elState.isPinned) {
    mutate(elState,  {
      ...elState,
      position: 'fixed',
    });
  }
}

const mutate = (obj, mutation) => {
  for(const key in mutation) {
    obj[key] = mutation[key];
  }
}